import { dealsApi } from '../api/dealsApi'
import { LEAD_SOURCES } from '../api/leadsApi'
import { useCachedSourceOptions, SOURCE_CACHE_TTL_MS } from './useCachedSourceOptions'

/**
 * Source filter options for the Deals table — the complete list of distinct
 * sources in the DB (localStorage-cached via useCachedSourceOptions), so the
 * Source filter is identical on every paginated page.
 */
export function useDealSourceFilterOptions(ttlMs: number = SOURCE_CACHE_TTL_MS) {
  return useCachedSourceOptions('crm_deal_source_options_v1', dealsApi.getSources, LEAD_SOURCES, ttlMs)
}
